export default __webpack_public_path__ + "static/media/edit_blue.6cdf360a.svg";